module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'timeline-row': _vm.timeline, 'with-padding': !_vm.timeline
    }
  }, [(_vm.timeline) ? _c('div', {
    staticClass: "timeline-icon",
    on: {
      "click": _vm.removeItem
    }
  }, [_c('div', {
    staticClass: "bg-primary-300"
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.getIcon,
    style: (_vm.getStyle)
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-flat timeline-content"
  }, [_c('div', {
    staticClass: "panel-body no-padding"
  }, [(_vm.item.type === 'video') ? _c('div', {
    staticClass: "video-container"
  }, [_c('iframe', {
    attrs: {
      "allowfullscreen": "",
      "frameborder": "0",
      "mozallowfullscreen": "",
      "src": _vm.item.content,
      "webkitallowfullscreen": ""
    }
  })]) : (_vm.item.type === 'instagram-post') ? _c('blockquote', {
    staticClass: "instagram-media",
    staticStyle: {
      "border": "0",
      "padding": "0",
      "width": "calc(100% - 2px)"
    },
    attrs: {
      "data-instgrm-captioned": "",
      "data-instgrm-version": "7"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "8px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "8px 0 0 0",
      "padding": "0 4px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#000",
      "font-family": "Arial,sans-serif",
      "font-size": "14px",
      "font-style": "normal",
      "font-weight": "normal",
      "line-height": "17px",
      "text-decoration": "none",
      "word-wrap": "break-word"
    },
    attrs: {
      "href": _vm.item.content,
      "target": "_blank"
    }
  })])])]) : (_vm.item.type === 'spotify') ? _c('div', [_c('iframe', {
    attrs: {
      "src": _vm.item.content,
      "width": "100%",
      "height": "380",
      "frameborder": "0",
      "allowtransparency": "true"
    }
  })]) : (_vm.item.type === 'soundcloud') ? _c('div', [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "166",
      "scrolling": "no",
      "frameborder": "no",
      "src": ("https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/" + (_vm.item.content) + "&color=0066cc")
    }
  })]) : (_vm.item.type === 'image') ? _c('ul', {
    staticClass: "media-list"
  }, [(_vm.item.description) ? _c('p', [_vm._v(_vm._s(_vm.item.description))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "thumbnail"
  }, [_c('a', {
    attrs: {
      "href": _vm.item.content
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.item.content,
      "alt": ""
    }
  })])])]) : (_vm.item.type === 'url') ? _c('ul', {
    staticClass: "media-list"
  }, [_c('li', {
    staticClass: "media stack-media-on-mobile"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('div', {
    staticClass: "thumb"
  }, [_c('a', {
    attrs: {
      "href": _vm.item.content,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "img-responsive img-rounded media-preview",
    attrs: {
      "src": _vm.item.image,
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h6', {
    staticClass: "media-heading"
  }, [_c('a', {
    attrs: {
      "href": _vm.item.content,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.title))])]), _vm._v(" "), _vm._m(2), _vm._v("\n                        " + _vm._s(_vm.item.description) + "\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.item.description && _vm.item.type !== 'url') ? _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "heading-elements"
  }, [_c('span', {
    staticClass: "heading-text"
  }, [_vm._v(_vm._s(_vm.item.description))])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#F8F8F8",
      "line-height": "0",
      "margin-top": "40px",
      "padding": "62.5% 0",
      "text-align": "center",
      "width": "100%"
    }
  }, [_c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "zoom-image"
  }, [_c('i', {
    staticClass: "fa fa-link"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list-inline list-inline-separate text-muted mb-5"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-tag position-left"
  }), _vm._v(" Something interesting")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b884616","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Item.vue
// module id = 359
// module chunks = 0